export default {
	'add-new-system-user': '',
	'the-system-user': '',
	'system-user': '',
	users: '',
	'are-you-sure-you-want-to-$-this-user': '',
	'user-state-is-changed-successfully': '',
	'not-matched': '',
	'new-value-replace-old': '',
}